import { Card, Flex, Space } from 'antd'
import dayjs from 'dayjs'
import { useParams } from 'react-router-dom'

import {
  GetSimeTbTreatmentPlanResponse,
  GetTreatmentPlanResponse,
  QrCodeType
} from 'src/api/requests'
import { QRCode, Text } from 'src/components'
import { dayMonthYearHourMinutesFormatSeparator } from 'src/libs'
import { useLocales } from 'src/locales'

import { TreatmentStatusTag } from '../PersonTreatmentsSection'
import { useStyles } from '../PersonTreatmentsSection/components/styles'

type Props = {
  data?: GetTreatmentPlanResponse | GetSimeTbTreatmentPlanResponse
}

export const SimeTBTreatmentHeader = ({ data }: Props) => {
  const { t } = useLocales()
  const { personId } = useParams()

  const { styles } = useStyles()

  return (
    <Flex gap={16}>
      <Card className={styles.headerCard}>
        <Flex vertical gap={8} className="full-width">
          <Flex justify="space-between">
            <Space>
              <Text weight={400}>{t('stock_applications.request_date')}:</Text>
              <Text strong>
                {dayjs(data?.created).format(
                  dayMonthYearHourMinutesFormatSeparator
                )}
              </Text>
            </Space>

            <TreatmentStatusTag status={data?.status} />
          </Flex>

          <Space>
            <Text weight={400}>
              {t('treatments.person_who_created_the_treatment')}
            </Text>
            <Text strong>
              {data?.prescribedBy?.firstName} {data?.prescribedBy?.lastName}
              {data?.legalEntity ? ` - ${data?.legalEntity?.name}` : ''}
            </Text>
          </Space>
        </Flex>
      </Card>
      <Card
        styles={{
          body: {
            padding: 16
          }
        }}
      >
        <QRCode
          type={QrCodeType.TREATMENT}
          content={`${personId} ${data?.id}`}
        />
      </Card>
    </Flex>
  )
}
